import { Alert, AlertDescription, AlertTitle } from '@/new/components/shadcn/alert';

interface Props {
  /** Why the staged documents can't be processed. Renders nothing when NULL. */
  message: string | null;
  className?: string;
}

/** Explains why the process button is disabled when the staged batch would exceed a credit limit. */
export function ProjectedCreditLimitCard({ message, className }: Props) {
  if (message === null || message === '') return null;

  return (
    <Alert variant="warning" className={className}>
      <div>
        <AlertTitle>These documents can't be processed</AlertTitle>
        <AlertDescription>{message}</AlertDescription>
      </div>
    </Alert>
  );
}
